/**
 * dualListBox.filter.js - Filter (search) for dualListBox.
 * Requires: dualListBox.js, jQuery
 *
 * Filters visible items by text. Uses .searchable inside each item for match.
 * Hides non-matching rows with .hidden-fieldlist (compatible with managecolumns markup).
 *
 * Usage after creating chooser:
 *   $.dualListBox.filter(chooser, '#filterInputId');
 * Or pass option when creating: filterInput: '#filterInputId'
 */
(function ($) {
	'use strict';

	var HIDDEN_CLASS = 'hidden-fieldlist';
	var SEARCHABLE_SELECTOR = 'span.searchable';

	function applyFilter(chooser, filterText) {
		if (!chooser || !chooser.getSourceList) return;
		var re = new RegExp($.trim(filterText).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
		var $source = chooser.getSourceList();
		var $dest = chooser.getDestinationList();

		function filterList($list) {
			$list.getFields().each(function () {
				var $item = $(this);
				var text = $item.find(SEARCHABLE_SELECTOR).text();
				if (!filterText || re.test(text)) {
					$item.removeClass(HIDDEN_CLASS);
				} else {
					$item.addClass(HIDDEN_CLASS);
				}
			});
		}

		filterList($source);
		filterList($dest);
	}

	function bindFilter(chooser, filterInput) {
		var $input = $(filterInput);
		if (!$input.length) return;

		$input.off('keyup.dlbFilter input.dlbFilter search.dlbFilter');
		$input.on('keyup.dlbFilter input.dlbFilter', function () {
			applyFilter(chooser, $input.val());
		});
		$input[0].addEventListener('search', function () {
			applyFilter(chooser, $input.val());
		});

		// Clear selection on hidden items when selection changes (match legacy behavior)
		if (chooser.getSourceList) {
			chooser.getSourceList().add(chooser.getDestinationList()).on('selectionChanged', function () {
				$('.' + HIDDEN_CLASS).removeClass('dlb-selected fc-selected');
			});
		}
	}

	$.dualListBox = $.dualListBox || {};
	$.dualListBox.filter = function (chooser, filterInput) {
		bindFilter(chooser, filterInput);
		return chooser;
	};
	$.dualListBox.applyFilter = applyFilter;

}(jQuery));
